module.exports = "<div class=\"weui_uploader\">\n  <cell class=\"weui_uploader_hd\">\n    <span slot=\"body\"><slot name=\"title\"></slot></span>\n    <span slot=\"footer\" v-if=\"count >= 0 && maxlength > 0\">{{count}}/{{maxlength}}</span>\n  </cell>\n  <div class=\"weui_uploader_bd\">\n    <slot name=\"uploader-files\"></slot>\n    <div class=\"weui_uploader_input_wrp\" v-if=\"hasInput\">\n      <input type=\"file\" class=\"weui_uploader_input\" accept=\"image/jpg,image/jpeg,image/png,image/gif\" multiple @change=\"dispatchChange\">\n    </div>\n  </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/uploader/uploader.vue
 ** module id = 127
 ** module chunks = 0
 **/